module.exports = __webpack_public_path__ + "img/video1.21065db7.jpg";